import React from 'react'

export default class extends React.Component {
    render() {

		return (

			<div className="row panel content-row editable mbot20 full-height">

            	<div className="col-sm-3 col-xs-4 ptop20 pbot20 pleft40 pright40">
        			<div className="profile-image breathe"></div>
            	</div>

				<div className="col-sm-5 col-xs-8 ptop20 pbot20">
        			<div className="mtop0 mbot20 full-title breathe"></div>
        			<div className="mtop0 mbot20 mbot0-xs sub-title breathe"></div>
        			<div className="mtop0 mbot20 mbot0-xs sub-title breathe"></div>
        			<div className="mtop0 mbot20 mbot0-xs sub-title breathe"></div>
            	</div>

				<div className="col-sm-4 col-xs-12 ptop20 pbot20 border-left-light-gray">

        			<div className="mtop0 mbot20 full-title breathe"></div>
        			<div className="mbot10 paragraph breathe"></div>
        			<div className="mbot10 paragraph breathe"></div>
        			<div className="mbot10 paragraph breathe"></div>
        			<div className="mbot10 paragraph breathe"></div>
        			<div className="mbot10 paragraph breathe"></div>

				</div>

        	</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Loading.jsx